import { useState, useEffect, useRef } from "react";
import { PHASES, PHASE_DOT, uid, T, mono } from "./utils";
import { Editable } from "./Components";
import { supabase } from "./supabase";

const INIT_ORTAK = [
  {title:"Panna Sofia",director:"Václav Kadrnka",type:"Feature",phase:"Aktif",flags:"CZ TR SK",status:"Post-Production",notes:"",driveUrl:""},
  {title:"Stratum",director:"Kötter & Singh",type:"Documentary",phase:"Aktif",flags:"RS TR XK",status:"Post-Production",notes:"",driveUrl:""},
  {title:"Sealand",director:"Sylvain George",type:"Documentary",phase:"Aktif",flags:"FR DE",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"The Ones Who Move Slowly",director:"Dilşad Aladağ",type:"Documentary 16mm",phase:"Aktif",flags:"TR",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"Sideritis",director:"Dilşad Aladağ",type:"Documentary 65'",phase:"Aktif",flags:"TR",status:"Post-Production",notes:"",driveUrl:""},
  {title:"Memories of Covas",director:"Paulo Carneiro",type:"Docu-fiction 16mm",phase:"Aktif",flags:"PT FR",status:"Çekim",notes:"",driveUrl:""},
  {title:"2019",director:"Affonso Uchoa",type:"Fiction",phase:"Aktif",flags:"BR",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"That Country",director:"Yusuf Elbaşı",type:"Feature Fiction",phase:"Aktif",flags:"TR DE",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"Sermon to the Void",director:"Hilal Baydarov",type:"112'",phase:"Tamamlandı",flags:"AZ MX TR",status:"Tamamlandı",notes:"Venezia 2025",driveUrl:""},
  {title:"An Incomplete Calendar",director:"Sanaz Sohrabi",type:"Essay Documentary",phase:"Tamamlandı",flags:"CA IR TR VE",status:"Festival",notes:"",driveUrl:""},
  {title:"Family Feeling",director:"Klementina Remeikaitė",type:"Fiction",phase:"Erken Aşama",flags:"LT",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"Dawn",director:"Suneil Sanzgiri",type:"Historical Epic",phase:"Erken Aşama",flags:"US PK TN",status:"Geliştirme",notes:"",driveUrl:""},
  {title:"Notes of a Crocodile",director:"Daphne / Daniel Mattas",type:"—",phase:"Erken Aşama",flags:"—",status:"—",notes:"",driveUrl:""},
  {title:"Yeni Film",director:"Darezhan Omirbayev",type:"—",phase:"Erken Aşama",flags:"KZ",status:"—",notes:"",driveUrl:""},
  {title:"Bad Man Good Boy",director:"Kavich Neang",type:"—",phase:"Değerlendirilecek",flags:"KH FR",status:"—",notes:"",driveUrl:""},
  {title:"Los animales magnéticos",director:"Gala Hernández López",type:"—",phase:"Değerlendirilecek",flags:"FR ES DE",status:"—",notes:"",driveUrl:""},
  {title:"End of the Present",director:"Andrea Bussmann",type:"—",phase:"Değerlendirilecek",flags:"—",status:"—",notes:"",driveUrl:""},
];

const ANA_GROUPS = ["Burak Çevik","Dilşad Aladağ","Short Films/Videos","Others"];
const ANA_GROUP_COLOR = {
  "Burak Çevik":"#e4572e",
  "Dilşad Aladağ":"#4a6fa5",
  "Short Films/Videos":"#3a8a7c",
  "Others":"#888",
};

function dbToFilm(p) {
  return {
    id:p.id, title:p.title, director:p.director||"", dirEmail:p.dir_email||"",
    producer:p.producer||"", producerEmail:p.producer_email||"",
    type:p.type||"", phase:p.phase, flags:p.flags?p.flags.split(" "):["—"],
    status:p.status||"", note:p.note||"", notes:p.notes||"", driveUrl:p.drive_url||"",
    groupLabel:p.group_label||"",
    screenerEmail:p.screener_email||"", screenerPassword:p.screener_password||"",
    tasks:(p.tasks||[])
      .sort((a,b)=>new Date(a.created_at)-new Date(b.created_at))
      .sort((a,b)=>a.done===b.done?0:a.done?1:-1)
      .map(t=>({id:t.id,text:t.text,done:t.done,dueDate:t.due_date||""}))
  };
}

function getWeekDays() {
  const now=new Date(); const dow=(now.getDay()+6)%7;
  const mon=new Date(now); mon.setDate(now.getDate()-dow); mon.setHours(0,0,0,0);
  const DAYS=["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"];
  return Array.from({length:7},(_,i)=>{
    const d=new Date(mon); d.setDate(mon.getDate()+i);
    return {label:`${d.getDate()} ${DAYS[i]}`,dateStr:`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`};
  });
}

async function addToGCal(googleToken,title,dateStr,timeStr) {
  if(!googleToken||!dateStr) return;
  try {
    let body;
    if(timeStr){
      const [h,m]=timeStr.split(":").map(Number);
      const start=new Date(dateStr); start.setHours(h,m,0,0);
      const end=new Date(start); end.setMinutes(end.getMinutes()+60);
      const tz=Intl.DateTimeFormat().resolvedOptions().timeZone;
      body={summary:title,start:{dateTime:start.toISOString(),timeZone:tz},end:{dateTime:end.toISOString(),timeZone:tz}};
    } else {
      body={summary:title,start:{date:dateStr},end:{date:dateStr}};
    }
    await fetch("https://www.googleapis.com/calendar/v3/calendars/primary/events",{method:"POST",headers:{Authorization:`Bearer ${googleToken}`,"Content-Type":"application/json"},body:JSON.stringify(body)});
  } catch(e){console.error(e);}
}

function DrivePanel({ film, updFilm, googleToken }) {
  const [urlInput, setUrlInput] = useState(film.driveUrl||"");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [stack, setStack] = useState([]);

  useEffect(()=>{setUrlInput(film.driveUrl||"");},[film.id,film.driveUrl]);
  useEffect(()=>{if(film.driveUrl&&googleToken)loadFolder(null);},[film.driveUrl,googleToken]); // eslint-disable-line

  function extractFolderId(url){if(!url)return null;const m=url.match(/[-\w]{25,}/);return m?m[0]:null;}

  async function loadFolder(folderId) {
    const rootId=extractFolderId(film.driveUrl);const targetId=folderId||rootId;
    if(!targetId||!googleToken)return;
    setLoading(true);setError("");
    try{
      const res=await fetch(`https://www.googleapis.com/drive/v3/files?q='${targetId}'+in+parents+and+trashed=false&fields=files(id,name,mimeType,size,modifiedTime)&orderBy=folder,name`,{headers:{Authorization:`Bearer ${googleToken}`}});
      const data=await res.json();
      if(data.error){setError(data.error.message);setLoading(false);return;}
      setFiles(data.files||[]);
    }catch(e){setError("Drive yüklenemedi");}
    setLoading(false);
  }

  function openFolder(id,name){setStack(s=>[...s,{id,name}]);loadFolder(id);}
  function goBack(){const ns=stack.slice(0,-1);setStack(ns);loadFolder(ns.length>0?ns[ns.length-1].id:null);}
  function openFile(f){
    if(f.mimeType==="application/vnd.google-apps.folder"){openFolder(f.id,f.name);return;}
    window.open(f.mimeType?.includes("google-apps")?`https://docs.google.com/file/d/${f.id}`:`https://drive.google.com/file/d/${f.id}/view`,"_blank");
  }
  function fileIcon(m){
    if(m==="application/vnd.google-apps.folder")return{color:"#4a90a4",label:"DIR"};
    if(m==="application/pdf")return{color:"#c0392b",label:"PDF"};
    if(m?.includes("spreadsheet")||m?.includes("excel"))return{color:"#2d7a2d",label:"XLS"};
    if(m?.includes("document")||m?.includes("word"))return{color:"#4a6fa5",label:"DOC"};
    if(m?.includes("image"))return{color:"#9b7ec8",label:"IMG"};
    if(m?.includes("video"))return{color:"#e4572e",label:"VID"};
    return{color:T.mute,label:"FILE"};
  }
  function fmtSize(b){if(!b)return"—";const k=parseInt(b)/1024;return k<1024?k.toFixed(0)+" KB":(k/1024).toFixed(1)+" MB";}

  return (
    <div>
      <div style={{...mono,fontSize:9,color:T.mute,marginBottom:6}}>Drive</div>
      <div style={{display:"flex",gap:5,marginBottom:6}}>
        <input value={urlInput} onChange={e=>setUrlInput(e.target.value)} placeholder="Drive URL…"
          style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 8px",fontSize:11,fontFamily:"'Inter',sans-serif"}}/>
        <button onClick={()=>{updFilm(film.id,{driveUrl:urlInput});setTimeout(()=>loadFolder(null),300);}} style={{...mono,fontSize:9,background:T.ink,color:"#fff",border:"none",borderRadius:2,padding:"5px 8px",cursor:"pointer"}}>Bağla</button>
        {film.driveUrl&&<button onClick={()=>window.open(film.driveUrl,"_blank")} style={{...mono,fontSize:9,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 8px",cursor:"pointer",color:T.mute}}>↗</button>}
      </div>
      {!googleToken&&<div style={{...mono,fontSize:9,color:T.mute}}>Google bağlı değil.</div>}
      {film.driveUrl&&googleToken&&(
        <div>
          {stack.length>0&&<div style={{display:"flex",alignItems:"center",gap:4,marginBottom:5}}><button onClick={goBack} style={{...mono,fontSize:9,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"2px 7px",cursor:"pointer",color:T.mute}}>← Geri</button><span style={{...mono,fontSize:9,color:T.mute}}>{stack.map(s=>s.name).join(" / ")}</span></div>}
          {loading&&<div style={{...mono,fontSize:9,color:T.mute}}>Yükleniyor…</div>}
          {error&&<div style={{...mono,fontSize:9,color:"#c0392b"}}>{error}</div>}
          {!loading&&files.length===0&&!error&&<div style={{...mono,fontSize:9,color:T.mute}}>Klasör boş.</div>}
          {!loading&&files.length>0&&(
            <div style={{border:`1px solid ${T.border}`,borderRadius:2,overflow:"hidden",maxHeight:180,overflowY:"auto"}}>
              {files.map((f,i)=>{const{color,label}=fileIcon(f.mimeType);const iF=f.mimeType==="application/vnd.google-apps.folder";return(
                <div key={f.id} onClick={()=>openFile(f)} style={{display:"grid",gridTemplateColumns:"24px 1fr 50px",gap:5,padding:"5px 8px",borderBottom:i<files.length-1?`1px solid ${T.borderLight}`:"none",cursor:"pointer",background:"#fff",alignItems:"center"}} onMouseEnter={e=>e.currentTarget.style.background="#f0ece6"} onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                  <span style={{...mono,fontSize:7,color,background:color+"18",padding:"1px 2px",borderRadius:2,textAlign:"center",fontWeight:600}}>{label}</span>
                  <span style={{fontSize:11,color:iF?T.ink:T.mute,fontWeight:iF?500:400,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</span>
                  <span style={{...mono,fontSize:8,color:T.mute,textAlign:"right"}}>{fmtSize(f.size)}</span>
                </div>
              );})}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function KanbanCard({ film, selected, onClick, onDelete }) {
  const pending = film.tasks.filter(t=>!t.done);
  const dot = PHASE_DOT[film.phase]||T.mute;
  return (
    <div onClick={onClick} draggable={false}
      style={{background:"#fff",border:`1px solid ${selected?T.accent:T.border}`,borderTop:`3px solid ${dot}`,borderRadius:4,padding:"12px",cursor:"pointer",marginBottom:8,position:"relative",transition:"border-color .1s,box-shadow .1s"}}
      onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.07)";if(!selected)e.currentTarget.style.borderColor="#c8c3bc";}}
      onMouseLeave={e=>{e.currentTarget.style.boxShadow="none";if(!selected)e.currentTarget.style.borderColor=T.border;}}>

      <div style={{marginBottom:6}}>
        <div style={{fontSize:13,fontWeight:600,color:T.ink,lineHeight:1.3,letterSpacing:"-0.01em"}}>{film.title}</div>
        <div style={{fontSize:11,color:T.mute,marginTop:2}}>{film.director}</div>
      </div>

      <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:pending.length>0?7:0}}>
        {film.status&&film.status!=="—"&&<span style={{...mono,fontSize:8,color:T.mute,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"1px 5px"}}>{film.status}</span>}
        {film.flags.filter(f=>f!=="—").map(flag=><span key={flag} style={{...mono,fontSize:8,color:"#4a6fa5",background:"#eaf0fa",borderRadius:2,padding:"1px 4px"}}>{flag}</span>)}
      </div>

      {pending.length>0&&(
        <div style={{borderTop:`1px solid ${T.borderLight}`,paddingTop:6}}>
          {pending.slice(0,3).map(t=>(
            <div key={t.id} style={{display:"flex",alignItems:"flex-start",gap:5,marginBottom:3}}>
              <span style={{width:3,height:3,borderRadius:"50%",background:T.border,flexShrink:0,marginTop:6}}/>
              <span style={{fontSize:10,color:T.mute,lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>{t.text}</span>
              {t.dueDate&&<span style={{...mono,fontSize:8,color:T.accent,flexShrink:0}}>{t.dueDate.slice(5)}</span>}
            </div>
          ))}
          {pending.length>3&&<div style={{...mono,fontSize:8,color:T.border,marginTop:2}}>+{pending.length-3} daha</div>}
        </div>
      )}

      <button onClick={e=>{e.stopPropagation();onDelete();}}
        style={{position:"absolute",top:6,right:6,background:"none",border:"none",color:"#c0392b",fontSize:13,cursor:"pointer",padding:0,opacity:0,transition:"opacity .15s"}}
        onMouseEnter={e=>e.currentTarget.style.opacity="1"} onMouseLeave={e=>e.currentTarget.style.opacity="0"}>×</button>
    </div>
  );
}

function DetailPanel({ film, onClose, updFilm, addTask, toggleTask, removeTask, assignTaskDate, deleteFilm, googleToken, onGoFestival }) {
  const [newTask,setNewTask]=useState("");
  const [newDue,setNewDue]=useState("");
  const [newTime,setNewTime]=useState("");
  const [sendGCal,setSendGCal]=useState(false);
  const [assigningTask,setAssigningTask]=useState(null);
  const [showDone,setShowDone]=useState(false);
  const weekDays=getWeekDays();

  const handleAdd=()=>{
    if(!newTask.trim())return;
    addTask(film.id,newTask,newDue,newTime,sendGCal,film.title);
    setNewTask("");setNewDue("");setNewTime("");setSendGCal(false);
  };

  return (
    <div style={{borderTop:`2px solid ${T.ink}`,background:"#fff",overflowY:"auto",flex:1,minHeight:0}}>
      {/* Header */}
      <div style={{padding:"14px 24px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"flex-start",position:"sticky",top:0,background:"#fff",zIndex:10}}>
        <div style={{flex:1,minWidth:0,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
              <span style={{width:7,height:7,borderRadius:"50%",background:PHASE_DOT[film.phase]||T.mute,flexShrink:0}}/>
              <span style={{...mono,fontSize:8,color:T.mute}}>{film.phase}</span>
            </div>
            <Editable value={film.title} onChange={v=>updFilm(film.id,{title:v})} style={{fontSize:16,fontWeight:600,color:T.ink,letterSpacing:"-0.01em"}} placeholder="Film adı"/>
            <div style={{fontSize:11,color:T.mute,marginTop:1}}>{film.director}</div>
          </div>
          <select value={film.phase} onChange={e=>updFilm(film.id,{phase:e.target.value})}
            style={{...mono,fontSize:10,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"4px 7px",color:T.ink,cursor:"pointer",outline:"none"}}>
            {PHASES.map(p=><option key={p} value={p}>{p}</option>)}
          </select>
          {film.groupLabel!==undefined&&(
            <select value={film.groupLabel} onChange={e=>updFilm(film.id,{groupLabel:e.target.value})}
              style={{...mono,fontSize:10,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"4px 7px",color:T.ink,cursor:"pointer",outline:"none"}}>
              {ANA_GROUPS.map(g=><option key={g} value={g}>{g}</option>)}
            </select>
          )}
          {onGoFestival&&(
            <button onClick={()=>onGoFestival(film.id)}
              style={{...mono,fontSize:9,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 9px",cursor:"pointer",color:"#3a8a7c",display:"flex",alignItems:"center",gap:5}}>
              <span style={{fontSize:11}}>🎬</span> Festival Stratejisi
            </button>
          )}
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,color:T.mute,cursor:"pointer",padding:0,flexShrink:0}}>×</button>
      </div>

      <div style={{padding:"18px 24px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:24,alignItems:"start"}}>
        {/* Info */}
        <div style={{display:"flex",flexDirection:"column",gap:7}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{...mono,fontSize:9,color:T.mute,width:36,flexShrink:0}}>Durum</span>
            <Editable value={film.status} onChange={v=>updFilm(film.id,{status:v})} style={{fontSize:12,color:T.ink}} placeholder="—"/>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{...mono,fontSize:9,color:T.mute,width:36,flexShrink:0}}>Dir.</span>
            <Editable value={film.director} onChange={v=>updFilm(film.id,{director:v})} style={{fontSize:12,color:T.ink}} placeholder="Yönetmen"/>
            <Editable value={film.dirEmail} onChange={v=>updFilm(film.id,{dirEmail:v})} style={{...mono,fontSize:9,color:film.dirEmail?T.accent:T.mute}} placeholder="mail"/>
            {film.dirEmail&&<span onClick={()=>window.open(`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(film.dirEmail)}`,"_blank")} style={{...mono,fontSize:9,background:T.ink,color:"#fff",padding:"2px 5px",borderRadius:2,cursor:"pointer"}}>↗</span>}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{...mono,fontSize:9,color:T.mute,width:36,flexShrink:0}}>Prod.</span>
            <Editable value={film.producer} onChange={v=>updFilm(film.id,{producer:v})} style={{fontSize:12,color:T.ink}} placeholder="Yapımcı"/>
            <Editable value={film.producerEmail} onChange={v=>updFilm(film.id,{producerEmail:v})} style={{...mono,fontSize:9,color:film.producerEmail?T.accent:T.mute}} placeholder="mail"/>
            {film.producerEmail&&<span onClick={()=>window.open(`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(film.producerEmail)}`,"_blank")} style={{...mono,fontSize:9,background:T.ink,color:"#fff",padding:"2px 5px",borderRadius:2,cursor:"pointer"}}>↗</span>}
          </div>
        </div>

        {/* Drive */}
        <DrivePanel film={film} updFilm={updFilm} googleToken={googleToken}/>

        {/* Screener + Notlar — aynı sütunda alt alta */}
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div style={{border:`1px solid #a8c8f0`,borderRadius:3,padding:"12px 14px",background:"#eaf4ff"}}>
            <div style={{...mono,fontSize:9,color:"#185FA5",marginBottom:10,letterSpacing:"0.15em"}}>Screener — indee.tv</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{...mono,fontSize:9,color:"#185FA5",width:48,flexShrink:0}}>E-posta</span>
                <Editable value={film.screenerEmail||""} onChange={v=>updFilm(film.id,{screenerEmail:v})}
                  style={{fontSize:12,color:"#185FA5",flex:1}} placeholder="mail@indee.tv"/>
                {film.screenerEmail&&(
                  <span onClick={()=>navigator.clipboard.writeText(film.screenerEmail)}
                    title="Kopyala" style={{...mono,fontSize:8,cursor:"pointer",color:"#185FA5",opacity:0.6,flexShrink:0,padding:"2px 5px",border:"1px solid #a8c8f0",borderRadius:2}}
                    onMouseEnter={e=>e.currentTarget.style.opacity="1"} onMouseLeave={e=>e.currentTarget.style.opacity="0.6"}>
                    kopyala
                  </span>
                )}
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{...mono,fontSize:9,color:"#185FA5",width:48,flexShrink:0}}>Şifre</span>
                <Editable value={film.screenerPassword||""} onChange={v=>updFilm(film.id,{screenerPassword:v})}
                  style={{fontSize:12,color:"#185FA5",flex:1,fontFamily:"monospace"}} placeholder="••••••"/>
                {film.screenerPassword&&(
                  <span onClick={()=>navigator.clipboard.writeText(film.screenerPassword)}
                    title="Kopyala" style={{...mono,fontSize:8,cursor:"pointer",color:"#185FA5",opacity:0.6,flexShrink:0,padding:"2px 5px",border:"1px solid #a8c8f0",borderRadius:2}}
                    onMouseEnter={e=>e.currentTarget.style.opacity="1"} onMouseLeave={e=>e.currentTarget.style.opacity="0.6"}>
                    kopyala
                  </span>
                )}
              </div>
              <a href="https://indee.tv" target="_blank" rel="noreferrer"
                style={{...mono,fontSize:8,color:"#185FA5",textDecoration:"none",opacity:0.7,marginTop:2,display:"inline-block"}}
                onMouseEnter={e=>e.currentTarget.style.opacity="1"} onMouseLeave={e=>e.currentTarget.style.opacity="0.7"}>
                indee.tv ↗
              </a>
            </div>
          </div>

          <div>
            <div style={{...mono,fontSize:9,color:T.mute,marginBottom:5}}>Notlar</div>
            <textarea value={film.notes||""} onChange={e=>updFilm(film.id,{notes:e.target.value})} placeholder="Notlar…"
              style={{width:"100%",height:100,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"6px 8px",fontSize:11,fontFamily:"'Inter',sans-serif",resize:"vertical",lineHeight:1.5,color:T.ink,outline:"none"}}/>
          </div>
        </div>

        {/* Tasks */}
        <div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
            <span style={{...mono,fontSize:9,color:T.mute}}>Görevler · {film.tasks.filter(t=>!t.done).length} bekliyor</span>
            {film.tasks.some(t=>t.done)&&(
              <button onClick={()=>setShowDone(s=>!s)} style={{...mono,fontSize:8,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"2px 6px",cursor:"pointer",color:T.mute}}>
                {showDone?`tamamlananları gizle`:`+ ${film.tasks.filter(t=>t.done).length} tamamlanan`}
              </button>
            )}
          </div>
          {film.tasks.filter(t=>showDone||!t.done).map(t=>(
            <div key={t.id} style={{borderBottom:`1px solid ${T.borderLight}`}}>
              <div style={{display:"flex",gap:7,alignItems:"center",padding:"5px 0"}}
                onMouseEnter={e=>{e.currentTarget.querySelector(".trm").style.opacity="1";e.currentTarget.querySelector(".tday").style.opacity="1";}}
                onMouseLeave={e=>{e.currentTarget.querySelector(".trm").style.opacity="0";e.currentTarget.querySelector(".tday").style.opacity="0";}}>
                <div onClick={()=>toggleTask(film.id,t.id)} style={{width:13,height:13,borderRadius:2,flexShrink:0,cursor:"pointer",background:t.done?T.ink:"transparent",border:`1.5px solid ${t.done?T.ink:T.border}`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {t.done&&<span style={{color:"#fff",fontSize:8}}>✓</span>}
                </div>
                <span onClick={()=>toggleTask(film.id,t.id)} style={{flex:1,fontSize:12,cursor:"pointer",color:t.done?T.mute:T.ink,textDecoration:t.done?"line-through":"none"}}>{t.text}</span>
                {t.dueDate&&<span style={{...mono,fontSize:9,color:T.accent,flexShrink:0}}>{t.dueDate}</span>}
                {!t.done&&<button className="tday" onClick={()=>setAssigningTask(assigningTask===t.id?null:t.id)} style={{opacity:0,...mono,fontSize:8,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"1px 5px",cursor:"pointer",color:T.mute,transition:"opacity .15s",flexShrink:0}}>{t.dueDate?"📅":"gün"}</button>}
                <button className="trm" onClick={()=>removeTask(film.id,t.id)} style={{opacity:0,background:"none",border:"none",color:"#c0392b",fontSize:13,cursor:"pointer",padding:0,transition:"opacity .15s"}}>×</button>
              </div>
              {assigningTask===t.id&&(
                <div style={{display:"flex",gap:3,flexWrap:"wrap",padding:"3px 0 7px 20px"}}>
                  {weekDays.map(wd=>(
                    <span key={wd.dateStr} onClick={()=>{assignTaskDate(film.id,t.id,wd.dateStr);setAssigningTask(null);}}
                      style={{...mono,fontSize:8,padding:"3px 6px",borderRadius:2,background:t.dueDate===wd.dateStr?T.accent:T.bg,color:t.dueDate===wd.dateStr?"#fff":T.mute,cursor:"pointer",border:`1px solid ${t.dueDate===wd.dateStr?T.accent:T.border}`}}>
                      {wd.label}
                    </span>
                  ))}
                  {t.dueDate&&<span onClick={()=>{assignTaskDate(film.id,t.id,"");setAssigningTask(null);}} style={{...mono,fontSize:8,padding:"3px 6px",borderRadius:2,background:T.bg,color:"#c0392b",cursor:"pointer",border:"1px solid #fcc"}}>kaldır</span>}
                </div>
              )}
            </div>
          ))}
          <div style={{marginTop:8,display:"flex",flexDirection:"column",gap:5}}>
            <input value={newTask} onChange={e=>setNewTask(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleAdd()} placeholder="Görev ekle…"
              style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"6px 8px",fontSize:12,fontFamily:"'Inter',sans-serif"}}/>
            <div style={{display:"flex",gap:5,alignItems:"center",flexWrap:"wrap"}}>
              <input type="date" value={newDue} onChange={e=>setNewDue(e.target.value)} style={{flex:1,minWidth:90,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 8px",fontSize:11,fontFamily:"'Inter',sans-serif",color:newDue?T.ink:T.mute}}/>
              <input type="time" value={newTime} onChange={e=>setNewTime(e.target.value)} style={{width:76,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 6px",fontSize:11,fontFamily:"'Inter',sans-serif",color:newTime?T.ink:T.mute}}/>
              {googleToken&&newDue&&<label style={{display:"flex",alignItems:"center",gap:4,cursor:"pointer",flexShrink:0}}><input type="checkbox" checked={sendGCal} onChange={e=>setSendGCal(e.target.checked)} style={{cursor:"pointer"}}/><span style={{...mono,fontSize:9,color:"#2d7a2d",whiteSpace:"nowrap"}}>GCal</span></label>}
              <button onClick={handleAdd} style={{background:T.ink,color:"#fff",border:"none",borderRadius:2,padding:"5px 10px",fontSize:13,cursor:"pointer",flexShrink:0}}>+</button>
            </div>
          </div>
        </div>

        {/* Delete — full width row at the bottom of the grid */}
        <div style={{gridColumn:"1/-1",paddingTop:4}}>
          <button onClick={deleteFilm} style={{...mono,fontSize:9,background:"none",border:`1px solid #fcc`,color:"#c0392b",borderRadius:2,padding:"6px 12px",cursor:"pointer"}}>Projeyi Sil</button>
        </div>
      </div>
    </div>
  );
}

export function ProjectsView({ kind, googleToken, onGoFestival }) {
  const [films,setFilms]=useState([]);
  const [loading,setLoading]=useState(true);
  const [selectedId,setSelectedId]=useState(null);
  const [dragOver,setDragOver]=useState(null);
  const dragFilmId=useRef(null);

  useEffect(()=>{loadData();},[kind]); // eslint-disable-line

  async function loadData() {
    setLoading(true);
    const{data,error}=await supabase.from("projects").select("*, tasks(*)").eq("kind",kind).order("created_at");
    if(error){setLoading(false);return;}
    if(data&&data.length>0){setFilms(data.map(dbToFilm));}
    else if(kind==="ortak"){
      const rows=INIT_ORTAK.map(f=>({id:uid(),title:f.title,director:f.director,dir_email:"",producer:"",producer_email:"",type:f.type,phase:f.phase,flags:f.flags,status:f.status,note:"",notes:f.notes,drive_url:"",kind:"ortak"}));
      await supabase.from("projects").insert(rows);
      const{data:d2}=await supabase.from("projects").select("*, tasks(*)").eq("kind",kind).order("created_at");
      setFilms((d2||[]).map(dbToFilm));
    }
    setLoading(false);
  }

  async function updFilm(id,patch) {
    setFilms(p=>p.map(f=>f.id===id?{...f,...patch}:f));
    const db={};
    if(patch.title!==undefined)db.title=patch.title;
    if(patch.director!==undefined)db.director=patch.director;
    if(patch.dirEmail!==undefined)db.dir_email=patch.dirEmail;
    if(patch.producer!==undefined)db.producer=patch.producer;
    if(patch.producerEmail!==undefined)db.producer_email=patch.producerEmail;
    if(patch.type!==undefined)db.type=patch.type;
    if(patch.phase!==undefined)db.phase=patch.phase;
    if(patch.flags!==undefined)db.flags=Array.isArray(patch.flags)?patch.flags.join(" "):patch.flags;
    if(patch.status!==undefined)db.status=patch.status;
    if(patch.note!==undefined)db.note=patch.note;
    if(patch.notes!==undefined)db.notes=patch.notes;
    if(patch.driveUrl!==undefined)db.drive_url=patch.driveUrl;
    if(patch.groupLabel!==undefined)db.group_label=patch.groupLabel;
    if(patch.screenerEmail!==undefined)db.screener_email=patch.screenerEmail;
    if(patch.screenerPassword!==undefined)db.screener_password=patch.screenerPassword;
    if(Object.keys(db).length)await supabase.from("projects").update(db).eq("id",id);
  }

  async function deleteFilm(id) {
    if(!window.confirm("Bu projeyi silmek istediğine emin misin?"))return;
    setFilms(p=>p.filter(f=>f.id!==id));
    if(selectedId===id)setSelectedId(null);
    await supabase.from("tasks").delete().eq("project_id",id);
    await supabase.from("projects").delete().eq("id",id);
  }

  async function addFilm(phase) {
    const id=uid();
    const nf={id,title:"New Project",director:"Director",dirEmail:"",producer:"",producerEmail:"",type:"—",phase,flags:["TR"],status:"Geliştirme",note:"",notes:"",driveUrl:"",tasks:[]};
    setFilms(p=>[...p,nf]);
    setSelectedId(id);
    await supabase.from("projects").insert({id,title:nf.title,director:nf.director,dir_email:"",producer:"",producer_email:"",type:"—",phase,flags:"TR",status:"Geliştirme",note:"",notes:"",drive_url:"",kind});
  }

  async function addTask(fid,text,dueDate,timeStr,sendGCal,filmTitle) {
    if(!text.trim())return;
    const t={id:uid(),text:text.trim(),done:false,dueDate:dueDate||""};
    setFilms(p=>p.map(f=>f.id===fid?{...f,tasks:[...f.tasks,t]}:f));
    await supabase.from("tasks").insert({id:t.id,project_id:fid,text:t.text,done:false,due_date:t.dueDate||null,etc:false});
    if(sendGCal&&dueDate&&googleToken)await addToGCal(googleToken,`${filmTitle} — ${text.trim()}`,dueDate,timeStr);
  }

  async function assignTaskDate(fid,tid,dateStr) {
    setFilms(p=>p.map(f=>f.id===fid?{...f,tasks:f.tasks.map(t=>t.id===tid?{...t,dueDate:dateStr}:t)}:f));
    await supabase.from("tasks").update({due_date:dateStr||null}).eq("id",tid);
  }

  async function toggleTask(fid,tid) {
    const f=films.find(x=>x.id===fid);const t=f?.tasks.find(x=>x.id===tid);if(!t)return;
    setFilms(p=>p.map(f=>f.id===fid?{...f,tasks:f.tasks.map(t=>t.id===tid?{...t,done:!t.done}:t)}:f));
    await supabase.from("tasks").update({done:!t.done}).eq("id",tid);
  }

  async function removeTask(fid,tid) {
    setFilms(p=>p.map(f=>f.id===fid?{...f,tasks:f.tasks.filter(t=>t.id!==tid)}:f));
    await supabase.from("tasks").delete().eq("id",tid);
  }

  function onDragStart(filmId){dragFilmId.current=filmId;}
  function onDragOver(e,col){e.preventDefault();setDragOver(col);}
  function onDragLeave(){setDragOver(null);}

  // For "ana" use group labels, for "ortak" use phases
  const columns = kind==="ana" ? ANA_GROUPS : PHASES;
  const colColor = kind==="ana"
    ? (col) => ANA_GROUP_COLOR[col]||"#888"
    : (col) => PHASE_DOT[col]||T.mute;
  const getColFilms = (col) => kind==="ana"
    ? films.filter(f=>f.groupLabel===col).sort((a,b)=>a.title.localeCompare(b.title,"tr"))
    : films.filter(f=>f.phase===col).sort((a,b)=>a.title.localeCompare(b.title,"tr"));
  const unassigned = kind==="ana" ? films.filter(f=>!f.groupLabel||!ANA_GROUPS.includes(f.groupLabel)) : [];

  const selectedFilm=films.find(f=>f.id===selectedId);

  if(loading)return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{...mono,color:T.mute}}>Loading</span></div>;

  return (
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden"}}>
      {/* Board */}
      <div style={{flex:selectedFilm?"0 0 auto":1,maxHeight:selectedFilm?"42vh":"none",overflowX:"auto",overflowY:selectedFilm?"auto":"hidden",padding:"24px 20px 24px",display:"flex",gap:14,alignItems:"flex-start",minWidth:0,transition:"max-height .15s"}}>
        <style>{`.kanban-col{min-height:${selectedFilm?"auto":"calc(100vh - 160px)"};}`}</style>
        {columns.map(col=>{
          const pf=getColFilms(col);
          const cc=colColor(col);
          const isOver=dragOver===col;
          return(
            <div key={col} className="kanban-col"
              onDragOver={e=>onDragOver(e,col)} onDragLeave={onDragLeave} onDrop={e=>{
                e.preventDefault();setDragOver(null);
                const id=dragFilmId.current;if(!id)return;
                const film=films.find(f=>f.id===id);if(!film)return;
                if(kind==="ana") updFilm(id,{groupLabel:col});
                else if(film.phase!==col) updFilm(id,{phase:col});
                dragFilmId.current=null;
              }}
              style={{width:220,flexShrink:0,background:isOver?cc+"22":cc+"0d",borderRadius:4,padding:"10px 8px",border:isOver?`2px dashed ${cc}`:`1px solid ${cc}33`,transition:"all .15s"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,paddingBottom:8,borderBottom:`2px solid ${cc}`}}>
                <div style={{display:"flex",alignItems:"center",gap:6}}>
                  <span style={{width:6,height:6,borderRadius:"50%",background:cc}}/>
                  <span style={{fontSize:12,fontWeight:600,color:T.ink}}>{col}</span>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:5}}>
                  <span style={{...mono,fontSize:10,color:T.mute}}>{pf.length}</span>
                  <button onClick={()=>addFilm(kind==="ana"?PHASES[0]:col)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:2,width:18,height:18,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:T.mute,fontSize:13,lineHeight:1,padding:0}}>+</button>
                </div>
              </div>
              {pf.map(film=>(
                <div key={film.id} draggable onDragStart={()=>onDragStart(film.id)} onDragEnd={()=>setDragOver(null)}>
                  <KanbanCard film={film} selected={selectedId===film.id} onClick={()=>setSelectedId(selectedId===film.id?null:film.id)} onDelete={()=>deleteFilm(film.id)}/>
                </div>
              ))}
              {pf.length===0&&<div style={{...mono,fontSize:9,color:T.border,textAlign:"center",padding:"16px 0"}}>boş</div>}
            </div>
          );
        })}
        {/* Unassigned column for ana */}
        {kind==="ana"&&unassigned.length>0&&(
          <div className="kanban-col" style={{width:220,flexShrink:0,background:T.bg,borderRadius:4,padding:"10px 8px",border:`1px dashed ${T.border}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,paddingBottom:8,borderBottom:`2px dashed ${T.border}`}}>
              <span style={{fontSize:12,fontWeight:600,color:T.mute}}>Atanmamış</span>
              <span style={{...mono,fontSize:10,color:T.mute}}>{unassigned.length}</span>
            </div>
            {unassigned.map(film=>(
              <div key={film.id} draggable onDragStart={()=>onDragStart(film.id)} onDragEnd={()=>setDragOver(null)}>
                <KanbanCard film={film} selected={selectedId===film.id} onClick={()=>setSelectedId(selectedId===film.id?null:film.id)} onDelete={()=>deleteFilm(film.id)}/>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Detail panel */}
      {selectedFilm&&(
        <DetailPanel film={selectedFilm} onClose={()=>setSelectedId(null)} updFilm={updFilm} addTask={addTask} toggleTask={toggleTask} removeTask={removeTask} assignTaskDate={assignTaskDate} deleteFilm={()=>deleteFilm(selectedFilm.id)} googleToken={googleToken} onGoFestival={onGoFestival}/>
      )}
    </div>
  );
}
